import { useQueryClient } from '@tanstack/react-query';
import { useIdempotentAction } from '@flexibilitypay/shared';

import { blockAccount, unblockAccount } from '../api/compliance.api';

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T060
 * @see functional/Specs/specs_cycle-2.md HU-11-FE
 */
export function useAccountComplianceMutations(accountId: string) {
  const queryClient = useQueryClient();

  function invalidateRelated() {
    queryClient.invalidateQueries({ queryKey: ['accounts-by-cuit'] });
    queryClient.invalidateQueries({ queryKey: ['user-by-cuit'] });
    queryClient.invalidateQueries({ queryKey: ['admin', 'dashboard-stats'] });
    queryClient.invalidateQueries({ queryKey: ['account', accountId] });
    queryClient.invalidateQueries({ queryKey: ['balance', accountId] });
  }

  const block = useIdempotentAction<{ reason: string }, void>(
    ({ reason }, ctx) =>
      blockAccount(accountId, reason, { idempotencyKey: ctx.idempotencyKey }),
    {
      scope: 'block-account',
      scopeId: accountId,
      onSuccess: invalidateRelated,
    },
  );

  const unblock = useIdempotentAction<{ reason: string }, void>(
    ({ reason }, ctx) =>
      unblockAccount(accountId, reason, { idempotencyKey: ctx.idempotencyKey }),
    {
      scope: 'unblock-account',
      scopeId: accountId,
      onSuccess: invalidateRelated,
    },
  );

  return { block, unblock };
}
